import { FC, useEffect, useRef } from 'react';

// Components
import DropdownSection from './DropdownSection';
import DropdownOption from './DropdownOption';

// Utils
import { classNames } from '@sportal365/smp-widget-utils';

// Types
import { IRounds, IStage } from '../../../../../../packages/types';

interface Props {
  options: IRounds[];
  isMobile?: boolean;
  currentStage?: IStage;
  currentRound?: { label: string; value: string };
  setRound: (value: string) => void;
  setStage: (value: string) => void;
}

export const DropdownMenu: FC<Props> = ({ options, isMobile, currentRound, currentStage, setRound, setStage }) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isMobile && dropdownRef.current) {
      const animation = dropdownRef.current.animate(
        [
          { transform: 'translateY(100%)', opacity: 0 },
          { transform: 'translateY(0)', opacity: 1 },
        ],
        {
          duration: 500,
          easing: 'ease-out',
          fill: 'forwards',
        },
      );

      return () => {
        animation.cancel();
      };
    }
  }, [isMobile]);

  return (
    <div
      ref={dropdownRef}
      className={classNames({
        'dropdown-menu-container overflow-y-auto right-0 rounded-4 z-10 opacity-100 bg-dropdownBtnColor shadow-[0px_4px_10px_0px_rgba(0,0,0,0.1)]':
          true,
        'max-w-full w-full max-h-[calc(100vh - 32px)] fixed top-7': isMobile,
        'max-w-[285px] w-[285px] max-h-[585px] absolute top-[58px]': !isMobile,
      })}
    >
      {options.map(({ stage, rounds }, index) => (
        <div key={stage.id}>
          <DropdownSection value={stage.name} index={index} />
          {rounds.map((option) => {
            const isSelected = option.value == currentRound?.value && stage.id == currentStage?.id;
            return (
              <DropdownOption
                key={option.value}
                {...option}
                stageId={stage.id}
                isSelected={isSelected}
                setStage={setStage}
                setRound={setRound}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
};
